module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2PG0w"))).then(() => module.bundle.root('1iHdE'));